import Mounter from 'shared/utils/mounter';
import documentReady from 'document-ready';
import CandidateView from './self_schedule/candidate_view/candidate_view';
import InterviewConfirmation from './self_schedule/candidate_view/interview_confirmation';
import CandidateViewMobile from './self_schedule/candidate_view/candidate_view_mobile';
import ErrorPage from './self_schedule/candidate_view/error_page';

const SelfSchedule = {
  CandidateView,
  CandidateViewMobile,
  ErrorPage,
  InterviewConfirmation,
} as const;

documentReady(() => {
  new Mounter({ SelfSchedule }).mountAll();
});
